var label = '标签页';
var name = 'tab';
export default {
  icon: 'icon-tab',
  label: label,
  name: name,
  children: 'tab-pane',
  rule: function rule() {
    return {
      type: 'el-tabs',
      children: []
    };
  },
  props: function props() {
    return [{
      type: 'select',
      field: 'type',
      title: '风格类型',
      options: [{
        label: 'default',
        value: 'default'
      }, {
        label: 'card',
        value: 'card'
      }, {
        label: 'border-card',
        value: 'border-card'
      }]
    }, {
      type: 'switch',
      field: 'closable',
      title: '标签是否可关闭'
    }, {
      type: 'select',
      field: 'tabPosition',
      title: '选项卡所在位置',
      options: [{
        label: 'top',
        value: 'top'
      }, {
        label: 'right',
        value: 'right'
      }, {
        label: 'left',
        value: 'left'
      }]
    }, {
      type: 'switch',
      field: 'stretch',
      title: '标签的宽度是否自撑开'
    }];
  }
};